import React from "react"

import * as styles from "./footer.module.scss"
import Modal from "./modal"
const Footer = ({ menuLinks, socialLinks, postPage }) => {
  return (
    <React.Fragment>
      <section className={styles.footerWrap}>
        <div>
          <div className={styles.copyrightwrap}>
            <div className={styles.copyright}>
              <p>
                &copy; Copyright {new Date().getFullYear()}
                {`, `}
              </p>
              <a
                style={{ boxShadow: "none",color: "#fff" }}
                href={"https://fundingfyre.com"}
                target="_blank"
                rel="noopener noreferrer"
              >
                {" FundingFyre"}
              </a>
            </div>
            <nav className={styles.menuLinks}>
              <ul>
                {menuLinks.map((link, index) => (
                  <li key={index}>
                    <a
                      href={link.slug}
                      key={index}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>
      </section>
      <Modal></Modal>
    </React.Fragment>
  )
}

export default Footer
